export interface FieldError {
  field: string
  errors: string[]
}

export interface ApiValidationError {
  response?: {
    status?: number
    data?: {
      message?: Array<{ field?: string; errors?: string[] }> | string
    }
  }
}

export function isApiValidationError(err: unknown): err is ApiValidationError {
  return typeof err === 'object' && err !== null && 'response' in err
}

export function getApiErrorStatus(err: unknown): number | undefined {
  return isApiValidationError(err) ? err.response?.status : undefined
}

export function extractFieldErrors(err: unknown): FieldError[] {
  if (!isApiValidationError(err)) return []
  const messageField = err.response?.data?.message
  if (!Array.isArray(messageField)) return []
  return messageField.filter(
    (m): m is FieldError =>
      typeof m.field === 'string' && Array.isArray(m.errors)
  )
}

// Raw BE messages can leak DB constraint / table names — always return the caller's fallback.
export function getApiErrorMessage(fallback: string): string {
  return fallback
}
